import Legend from '../components/Legend.vue'
import Draggable from '../components/Draggable.vue'

export default {
  components: {
    GraphLegend: Legend,
    Draggable: Draggable
  },
  props: {
    showLegend: {
      type: Boolean,
      default: true
    },
    draggableLegend: {
      type: Boolean,
      default: true
    },
    legendWidth: {
      type: Number,
      default: 100
    }
  },
  data () {
    return {
      legendPosition: null
    }
  },
  watch: {
    graphWidth () {
      this.updateLegendPosition()
    },
    height () {
      this.updateLegendPosition()
    }
  },
  methods: {
    getLegendPosition () {
      if (this.draggableLegend && this.showLegend) {
        const coords = this.$refs.draggableLegend.getCoordinates()
        return {
          x: coords.x,
          y: coords.y,
          width: this.width,
          height: this.height
        }
      }
      return false
    },
    setLegendPosition (position) {
      if (typeof position.x === 'undefined') {
        return
      }
      this.legendPosition = position
      if (this.draggableLegend) {
        let x = this.legendWidth + this.marginRight - this.width + (
          position.width - this.marginRight - this.legendWidth + position.x
        ) * position.width / this.width
        if (x < this.legendWidth - this.graphWidth) {
          x = this.legendWidth - this.graphWidth
        }
        if (x > 0) {
          x = 0
        }
        let y = (this.marginTop + position.y) * this.height / position.height - this.marginTop
        if (y < 0) {
          y = 0
        }
        if (y > this.height) {
          y = 0
        }
        
        if (typeof this.$refs.draggableLegend !== 'undefined') {
          this.$refs.draggableLegend.setCoordinates({
            x: x,
            y: y
          })
        }
      }
    },
    updateLegendPosition () {
      if (this.draggableLegend) {
        if (this.legendPosition !== null) {
          this.setLegendPosition(this.legendPosition)
        } else {
          if (typeof this.$refs.draggableLegend !== 'undefined') {
            this.$refs.draggableLegend.setCoordinates({
              x: 0,
              y: 0
            })
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/d3vue/mixins/draggable-legend.js